module.exports = __webpack_public_path__ + "img/logo1.ab5df12c.png";